import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const ModalChangePassword = ({ estado, typeModal, onCloseModal, onReturnValue, item }) => {
  const [newPassword, setNewPassword] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!newPassword.trim()) {
      alert("Por favor, ingrese una nueva contraseña.");
      return;
    }
    onReturnValue(
      {
        idadmin: item.idadmin,
        cuenta: item.cuenta,
        newPassword: newPassword
      },
      false,
      typeModal
    );
    setNewPassword("");
  };

  const handleClose = () => {
    setNewPassword("");
    onCloseModal();
  };

  return (
    <Modal show={estado} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Cambiar Contraseña</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Cuenta</Form.Label>
            <Form.Control
              type="text"
              value={item.cuenta}
              disabled
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Nueva Contraseña</Form.Label>
            <Form.Control
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Ingrese la nueva contraseña"
              required
            />
          </Form.Group>
        
          <Button variant="danger" onClick={handleClose} className="ms-2">
            Cancelar
          </Button>
            <Button variant="primary" type="submit">
            Guardar
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};
export default ModalChangePassword;